import { IconModel } from '../models/icon/icon.model';
import { AlertModel } from '../models/alert/alert.model';
import { AlertStylingModel } from '../models/alert/alert-styling.model';

export const /** @type {?} */ AlertTemplates = {
  defaultTemplate: {
    property: new AlertModel({
      display: true,
      disable: false,
      id: '',
      compTemplate: 'default/alert-template',
      content: {
        title: '',
        message: '',
        templateName: ''
      },
      position: '',
      timeOut: 3000,
      extendedTimeOut: 1000,
      inform: {
        show: true,
        icon: new IconModel({ name: 'info' })
      },
      confirm: {
        show: true,
        icon: new IconModel({ name: 'check' })
      },
      cancel: {
        show: true,
        icon: new IconModel({ name: 'close' })
      },
      progressBar: true,
      progressAnimation: 'decreasing',
      autoDismiss: false,
      maxOpened: 0,
      newestOnTop: true,
      onActivateTick: false,
      tapToDismiss: false,
      preventDuplicates: false
    }),
    style: new AlertStylingModel()
  },
  warningTemplate: {
    property: new AlertModel({
      display: true,
      id: '',
      compTemplate: 'default/alert-template',
      content: {
        title: '',
        message: '',
        templateName: ''
      },
      position: '',
      timeOut: 3000,
      extendedTimeOut: 1000,
      inform: {
        show: true,
        icon: new IconModel({ name: 'warning' })
      },
      confirm: {
        show: true,
        icon: new IconModel({ name: 'check' })
      },
      cancel: {
        show: true,
        icon: new IconModel({ name: 'close' })
      },
      progressBar: true,
      progressAnimation: 'decreasing',
      autoDismiss: false,
      maxOpened: 0,
      newestOnTop: true,
      onActivateTick: false,
      tapToDismiss: false,
      preventDuplicates: false
    }),
    style: new AlertStylingModel()
  },
  errorTemplate: {
    property: new AlertModel({
      display: true,
      id: '',
      compTemplate: 'default/alert-template',
      content: {
        title: '',
        message: '',
        templateName: ''
      },
      position: '',
      timeOut: 3000,
      extendedTimeOut: 1000,
      inform: {
        show: true,
        icon: new IconModel({ name: 'error' })
      },
      confirm: {
        show: true,
        icon: new IconModel({ name: 'check' })
      },
      cancel: {
        show: true,
        icon: new IconModel({ name: 'close' })
      },
      progressBar: true,
      progressAnimation: 'decreasing',
      autoDismiss: false,
      maxOpened: 0,
      newestOnTop: true,
      onActivateTick: false,
      tapToDismiss: false,
      preventDuplicates: false
    }),
    style: new AlertStylingModel()
  }
}
